import { render, staticRenderFns } from "./SafiePage.vue?vue&type=template&id=c3ad823a&scoped=true&"
import script from "./SafiePage.vue?vue&type=script&lang=js&"
export * from "./SafiePage.vue?vue&type=script&lang=js&"
import style0 from "./SafiePage.vue?vue&type=style&index=0&id=c3ad823a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3ad823a",
  null
  
)

export default component.exports